// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"767":"d6747b6d","793":"2cc31538","812":"5d037ed5"}[chunkId] + ".css";
};